export var ModifierKeysEnum;
(function (ModifierKeysEnum) {
    // No modifiers are pressed.
    ModifierKeysEnum[ModifierKeysEnum["None"] = 0] = "None";
    // THE alt key
    ModifierKeysEnum[ModifierKeysEnum["Alt"] = 1] = "Alt";
    // the control key
    ModifierKeysEnum[ModifierKeysEnum["Control"] = 2] = "Control";
    // the shift key
    ModifierKeysEnum[ModifierKeysEnum["Shift"] = 4] = "Shift";
    // the window logo key
    ModifierKeysEnum[ModifierKeysEnum["Windows"] = 8] = "Windows";
})(ModifierKeysEnum || (ModifierKeysEnum = {}));
//# sourceMappingURL=modifierKeys.js.map